import { FC, ReactNode } from 'react'
// Import direto (e não pelo barrel `..`): o barrel reexporta este próprio arquivo, e a dependência
// circular obriga qualquer consumidor a carregar o app inteiro para renderizar um rótulo.
import { InfoTooltip } from '../Info/InfoTooltip'
import { FontSize } from '../../../_metronic/helpers'

type ILabel = {
  children?: ReactNode
  className?: string
  disabled?: boolean
  isRequired?: boolean
  infoText?: string
  size?: FontSize
  highlight?: boolean
  htmlFor?: string
}

export const Label: FC<ILabel> = ({
  children = '',
  className = '',
  disabled = false,
  isRequired,
  infoText = '',
  size = FontSize.XSmall,
  highlight,
  htmlFor,
}) => (
  <div className={`d-flex ${className}`}>
    <label
      htmlFor={htmlFor}
      className={`${size} fw-bolder ${disabled ? 'disabled' : ''} ${isRequired ? 'required' : ''}`}
    >
      {children}
    </label>
    {infoText && <InfoTooltip text={infoText} className='ms-2' highlight={highlight} />}
  </div>
)
